import { createReducer, on } from '@ngrx/store';
import * as fromProfessorAction from '../actions/professor.action';
export const featureKey = 'professor';

import { GradeDetails } from 'src/app/models/grades.models';

export interface State {
	professor: {
		data: Array<any>;
		isLoaded: Boolean;
	};

	subjects: {
		data: Array<any>;
		isLoaded: Boolean;
		students: {
			data: [];
			isLoaded: Boolean;
		};
		workItems: {
			data: [],
			isLoaded: Boolean;
		}
	};

	grades: {
		data: Array<any>;
		isLoaded: boolean;
	};

	gradeDetails: {
		data: any;
		isLoaded: boolean;
	};
}	

export const initialState: State = {
	professor: {
		data: [],
		isLoaded: false
	},

	subjects: {
		data: [],
		isLoaded: false,
		students: {
			data: [],
			isLoaded: false
		},
		workItems: {
			data: [],
			isLoaded: false
		}
	},

	grades: {
		data: [],
		isLoaded: false
	},

	gradeDetails: {
		data: {},
		isLoaded: false
	}
};

export const reducer = createReducer(
	initialState,
	on(fromProfessorAction.getProfessorsSuccess, (state: State, props: any) => ({
		...state,
		professor: { data: props.data, isLoaded: true },
	})),

	on(fromProfessorAction.getProfessorSubjectsSuccess, (state: State, props: any) => ({
		...state,
		subjects: {
			...state.subjects,
			data: props.data,
			isLoaded: true
		}
	})),

	on(fromProfessorAction.getProfSubjectStudentsSuccess, (state: State, props: any) => ({
		...state,
		subjects: {
			...state.subjects,
			students: { data: props.data, isLoaded: true }
		}
	})),

	on(fromProfessorAction.getProfSubjectWorkItemsSuccess, (state: State, props: any) => ({
		...state,
		subjects: {
			...state.subjects,
			workItems: { data: props.data, isLoaded: true }
		}
	})),

	on(fromProfessorAction.getWorkItemStudentsGradeSuccess, (state: State, props: any) => ({
		...state,
		grades: {
			...state.grades,
			data: props.data,
			isLoaded: true
		}
	})),

	on(fromProfessorAction.getGradeDetailsSuccess, (state: State, props: any) => ({
		...state,
		gradeDetails: {
			...state.gradeDetails,
			data: props.data,
			isLoaded: true
		}
	})),
);